import Image from "next/image";
import type { TeamMember } from "./types";

export function TeamMemberCard({ member }: { member: TeamMember }) {
  return (
    <div className="group flex flex-col">
      <div className="bg-surface-2 border-border relative aspect-[3/4] w-full overflow-hidden rounded-xl border transition-all duration-300 group-hover:translate-y-[-3px] group-hover:shadow-xl group-hover:shadow-black/30">
        {member.image ? (
          <Image
            src={member.image}
            alt={`${member.name} photo`}
            fill
            unoptimized
            className="object-cover object-top grayscale transition-[filter] duration-300 group-hover:grayscale-0"
            sizes="(max-width: 640px) 50vw, (max-width: 1024px) 33vw, 25vw"
          />
        ) : (
          <div className="text-muted-foreground absolute inset-0 flex items-center justify-center text-3xl font-semibold">
            {member.initials}
          </div>
        )}
      </div>
      <div className="mt-4">
        <div className="text-foreground text-sm leading-snug font-semibold">{member.name}</div>
        <div className="text-muted-foreground mt-0.5 text-sm">{member.role}</div>
      </div>
    </div>
  );
}
